<h3>Overall Student Results Semester wise</h3>
<div class="container-fluid">
  <div class="row g-4">
    <div class="col-12">
      <mat-card>
        <mat-card-content>
          <form [formGroup]="gradeCardForm">
            <div>
              <!-- Year & Month in same row -->
              <div class="row">
                <!-- Month -->
                <div class="col-md-6">
                  <mat-form-field class="w-100" appearance="outline">
                    <mat-label>Select Month</mat-label>
                    <mat-select formControlName="selectedMonth">
                      <mat-option *ngFor="let month of months" [value]="month.months_name">
                        {{ month.months_name }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>

                <!-- Year -->
                <div class="col-md-6">
                  <mat-form-field class="w-100" appearance="outline">
                    <mat-label>Select Year</mat-label>
                    <mat-select formControlName="selectedYear">
                      <mat-option *ngFor="let year of yearss" [value]="year.year_name">
                        {{ year.year_name }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>

              <!-- Course Row -->
              <div class="row">
                <div class="col-md-6">
                  <mat-form-field class="w-100" appearance="fill">
                    <mat-label>Select Course</mat-label>
                    <mat-select formControlName="selectCourse">
                      <mat-option *ngFor="let course of courseNames" [value]="course.id">
                        {{ course.name }}-{{course.crs_code}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>

              <!-- Buttons -->
              <div class="mt-3">
                <button mat-raised-button color="primary" (click)="Display()">Display Result</button>
                &nbsp;&nbsp;
                <button mat-raised-button color="primary" (click)="Excel()">Excel</button>
              </div>
            </div>
          </form>










        </mat-card-content>
      </mat-card>
    </div>
  </div>
</div>


          <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">

  <ng-container *ngFor="let column of displayedColumns.label" [matColumnDef]="column">
    <th mat-header-cell *matHeaderCellDef> {{ column }} </th>
    <td mat-cell *matCellDef="let element"> {{ element[column] }} </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns.label"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns.label;"></tr>

</table>